<template>
  <div class="text-center">
    <wtk-alert />
    <wtk-confirm />
    <wtk-loading />
    <wtk-prompt />
    <wtk-toast />
  </div>
</template>

<script>
import wtkAlert from "./alert";
import wtkConfirm from "./confirm";
import wtkLoading from "./loading";
import wtkPrompt from "./prompt";
import wtkToast from "./toast";
export default {
  name: "WtkMessage",
  components: {
    wtkAlert,
    wtkConfirm,
    wtkLoading,
    wtkPrompt,
    wtkToast,
  },
};
</script>